export const gitCommit = '3fb377c3'
